// import { S3_URL } from 'constants/index';
import { DefaultTheme } from 'styled-components';
import { getDomain } from '../modules/helpers';
import AcmeTitle from './AcmeTitle';
import Contact from './Contact';
import TitleOne from './TitleOne';

export const { hostname } = window.location;

type ThemeMap = {
  [key: string]: DefaultTheme;
};

const DevThemesMap: ThemeMap = {
  'contact.Tifle.io': Contact,
  'titleone.Tifle.io': TitleOne,
  'acmetitle.kellermortgage.com': AcmeTitle,
};

const ProdThemesMap: ThemeMap = {
  'contact.Tifle.io': Contact,
  'titleone.Tifle.io': TitleOne,
  'acmetitle.kellermortgage.com': AcmeTitle,
};

const themesMap =
  process.env.REACT_APP_ENV === 'production' ? ProdThemesMap : DevThemesMap;

const domain = getDomain();
export const theme = themesMap[domain] || Contact;
export default theme;

// export const getAssetUrl = (fileName, folderName = 'images') =>
//   `${S3_URL}/${domain}/${folderName}/${fileName}`;
